/** Case-insensitive substring test; an empty/blank needle always matches. */
export function includesText(haystack: string | undefined | null, needle: string): boolean {
  const term = needle.trim().toLowerCase();
  if (!term) {
    return true;
  }
  return (haystack ?? '').toLowerCase().includes(term);
}

/**
 * Membership test for a multi-select filter: an empty selection means "no constraint" (matches
 * everything); otherwise the item's value must be one of the selected values.
 */
export function matchesSelection(selected: readonly string[], value: string | undefined | null): boolean {
  if (selected.length === 0) {
    return true;
  }
  return value != null && selected.includes(value);
}
